// extracted by mini-css-extract-plugin
export default {"mainContent":"SiteSettings_mainContent__yum+0","emailList":"SiteSettings_emailList__6bhlB","deleteEmail":"SiteSettings_deleteEmail__+rSGd"};